import './loader.module.styles.css';

const Loader = () => {
  return (
    <div className="loader_container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
